import packageInfo from '../../package.json';

const appVersion =
  process.env.REACT_APP_BUILD_LABEL ||
  process.env.REACT_APP_VERSION ||
  packageInfo.version ||
  'dev';

export default appVersion;
